var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":"","text-center":"","pt-5":""}},[_c('v-img',{attrs:{"contain":"","src":require("../../assets/sarpaodisha_1.png")}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }